import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '../../styles';
export const TextItalicIcon = ({ color, ...props }) => {
    const theme = useTheme();
    return (_jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { d: "M15.625 5.625V4.375H7.5V5.625H10.7125L7.98125 14.375H4.375V15.625H12.5V14.375H9.2875L12.0187 5.625H15.625Z", fill: color ?? theme.colors.grey90 }) }));
};
//# sourceMappingURL=text_italic_icon.js.map